
const FILES_ICONS = {
    'text/csv': 'fal fa-file-csv',
    'csv': 'fal fa-file-csv',
    'text/plain': 'fal fa-file-alt',
    'txt': 'fal fa-file-alt',
    '7z': 'fal fa-file-archive',
    'zip': 'fal fa-file-archive',
    'application/zip': 'fal fa-file-archive',
    'application/x-rar': 'fal fa-file-archive',
    'rar': 'fal fa-file-archive',
    'application/vnd.oasis.opendocument.spreadsheet': 'fal fa-file-excel',
    'application/vnd.ms-excel': 'fal fa-file-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'fal fa-file-excel',
    'xls': 'fal fa-file-excel',
    'xlsx': 'fal fa-file-excel',
    'ods': 'fal fa-file-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fal fa-file-word',
    'application/vnd.oasis.opendocument.text': 'fal fa-file-word',
    'application/msword': 'fal fa-file-word',
    'doc': 'fal fa-file-word',
    'docx': 'fal fa-file-word',
    'dot': 'fal fa-file-word',
};

/**
 * Klasa pliku dla listy plików
 */
export class File {

    constructor(props) {
        Object.assign(this, props);
    }

    getType() {
        return String(this.type || this.mime_type || this.mimeType || this.momeType);
    }

    /**
     * Zwraca czy plik jest dokumentem PDF
     * @return {boolean}
     */
    isPdf() {
        return Boolean(this.getType().match(/pdf/i));
    }

    /**
     * Zwraca czy plij jest obrazkiem
     * @return {boolean}
     */
    isImage() {
        return Boolean(this.getType().match(/image/i));
    }

    /**
     * Zwraca czy plik jest plikiem wideo
     * @return {boolean}
     */
    isVideo() {
        return Boolean(this.getType().match(/video/i));
    }

    /**
     * Zwraca czy plik jest plikiem audio
     * @return {boolean}
     */
    isAudio() {
        return Boolean(this.getType().match(/audio/i));
    }

    /**
     * Zwraca czy plik jest możliwy do wyświetlenia w przeglądarce
     * @return {boolean}
     */
    isEmbbedable() {
        return this.isPdf() || this.isImage() || this.isVideo() || this.isAudio();
    }

    /**
     * Zwraca czy plik jest załączonym zdefiniowanym plikiem
     * @return {boolean}
     */
    isLink() {
        return Boolean(this.linkable);
    }


    isLinkable() {
        return Boolean(this.linkable);
    }

    /**
     * Zwraca klasę CSS ikony pliku
     * @return {string}
     */
    getFaIconName() {
        if (this.isPdf()) {
            return 'fal fa-file-pdf text-danger';
        }

        if (this.isImage()) {
            return 'fal fa-file-image';
        }

        if (this.isVideo()) {
            return 'fal fa-file-video'
        }

        if (this.isAudio()) {
            return 'fal fa-file-audio';
        }

        return FILES_ICONS[this.getType()] || FILES_ICONS[this.extension] || 'fal fa-file';
    }
}
